/* ----------------------------------------------------------------------------------- 
   Name:				AQDAjaxResponse.js
   Created:			Matthew Zalewski
   Date:				16 December 2009
   Description:	Handles an AjaxResponse returned by a controller/action
  						  A response will be structured in the following format
							  {
  								Success: true/false,
								  ActionMessages:	[
  									{
										  Name: 'ShowDialog/UpdateModel/OtherActionName',
										  <Other properties may be inserted here>
									  },
									  {
  										Name: 'ShowDialog/UpdateModel/OtherActionName',
										  <Other properties may be inserted here>
									  }
								  ]
							  }
								
								If you add a custom action, you can extend the ajaxActionHandlers in your own script using the following jQuery code:
								$.extend($.ajaxActionHandlers, {
									functionName: function(actionJson) {
										// handle action here
									}
								}
*/
$.extend($, {
  messageTypes: {
    "Info": 0,
    "Error": 1,
    "Warning": 2,
    "Confirm": 3,
    "Custom": 4,
    "Reload": 5
  },
  ajaxActionHandlers: {
		
		Redirect: function (actionJson, originalEventData) {
      window.location = actionJson.Url;
    },
    AjaxActionCall: function (actionJson, originalEventData, promise) {
			if (promise) { 
				$.getAjaxResponse(actionJson.Url).then(function(data) { promise && promise.resolve(data) || data });
				return true;
			}
	    $.get(actionJson.Url);
			return true;
    },
    Reload: function (actionJson, originalEventData) {

      window.location.reload();
    },
    // The default ShowMessage implementation
    // Shows a dialog with the supplied message details
    ShowMessage: function (actionJson, originalEventData, promise) {

      if (actionJson.MessageType == $.messageTypes.Info) {
        if (actionJson.Options["okButton"] != undefined && actionJson.Options["okButton"].Actions != undefined && actionJson.Options["okButton"].Actions.length > 0)
          $.infoDialog(actionJson.Message, actionJson.Title, function () {
            for (var i = 0; i < actionJson.Options["okButton"].Actions.length; i++) {

              var responseMsg = actionJson.Options["okButton"].Actions[i];
              var actionName = responseMsg.Name;

              var handler = $.ajaxActionHandlers[actionName];
              if (handler != null)
                handler(responseMsg, originalEventData, promise);
            }
          });
        else{
          $.infoDialog(actionJson.Message, actionJson.Title);
					promise && promise.resolve(originalEventData);
				}
      } else if (actionJson.MessageType == $.messageTypes.Reload) {
        $.infoDialog(actionJson.Message, actionJson.Title);
        window.location.reload();
      } else if (actionJson.MessageType == $.messageTypes.Error) {
        if (actionJson.Options["okButton"] != undefined && actionJson.Options["okButton"].Actions != undefined && actionJson.Options["okButton"].Actions.length > 0)
          $.infoDialog(actionJson.Message, actionJson.Title, function () {
            for (var i = 0; i < actionJson.Options["okButton"].Actions.length; i++) {
              var responseMsg = actionJson.Options["okButton"].Actions[i];
              var actionName = responseMsg.Name;
              var handler = $.ajaxActionHandlers[actionName];
              if (handler != null)
                handler(responseMsg, originalEventData, promise);
            }
          });
        else {
          if (actionJson.Detail == undefined || actionJson.Detail == null || actionJson.Detail == '')
            $.errorDialog(actionJson.Message, actionJson.Title);
          else
            $.errorDetailDialog(actionJson.Message, actionJson.Title, actionJson.Detail);
        }
      } else if (actionJson.MessageType == $.messageTypes.Confirm) {
        $.confirmDialog(actionJson.Message, actionJson.Title, function () {
					var handled = false;
				  	if (actionJson.Options["yes"] != null) { 
				
						for (var i = 0; i < actionJson.Options["yes"].Actions.length; i++) {

							var responseMsg = actionJson.Options["yes"].Actions[i];
							var actionName = responseMsg.Name;

							var handler = $.ajaxActionHandlers[actionName];
							if (handler != null) { 
            
								handled = handler(responseMsg, originalEventData, promise);
							}
						}
          }
					if (!handled) { 
						promise && promise.resolve(originalEventData);
					}
        },
				function () {
					var handled = false;
					if (actionJson.Options["no"] != null) { 
						for (var i = 0; i < actionJson.Options["no"].Actions.length; i++) {
						
							var responseMsg = actionJson.Options["no"].Actions[i];
							var actionName = responseMsg.Name;
							var handler = $.ajaxActionHandlers[actionName];
							if (handler != null) { 
								handled = handler(responseMsg, originalEventData, promise);
							}
						
						 }
					}
					if (!handled) { 
						promise && promise.resolve(originalEventData);
					}
				});
      } else if (actionJson.MessageType == $.messageTypes.Custom) {
        var buttons = {};
        for (var buttonId in actionJson.Options) {
          var btn = actionJson.Options[buttonId];
          var createButton = function (button) {
            return function () {
              for (var i = 0; i < button.Actions.length; i++) {
                var responseMsg = button.Actions[i];
                var actionName = responseMsg.Name;

                var handler = $.ajaxActionHandlers[actionName];

                if (handler != null)
                  handler(responseMsg, originalEventData, promise);
              }
              $(this).dialog('destroy');
            };
          };
          buttons[btn.OptionText] = createButton(btn);
        }
        $.customDialog(actionJson.Message, actionJson.Title, buttons);
      }
      return true;
    },
    RevertForm: function (actionJson, originalEventData) {
      var form = originalEventData.source;
      if (form != undefined && form != null && $(form).get(0).tagName.toLowerCase() == "form") {
        $(form).find('input[type="hidden"]').each(function () {
          if ($(this).attr('name').endsWith('.original')) {
            $(form).find('input[name="' + $(this).attr('name').replace('.original', '') + '"]').val($(this).val());
            $(form).find('textarea[name="' + $(this).attr('name').replace('.original', '') + '"]').text($(this).val());
          }
        });
        return true;
      }
      return false;
    },
    UpdateModel: function (actionJson, originalEventData) {
      var prefix = "";
      if (actionJson.Prefix != "")
        prefix = actionJson.Prefix + ".";
      var form = originalEventData.source;
      if (form == undefined || (actionJson.FilterByForm != undefined && actionJson.FilterByForm == false))
        form = document;

      for (var name in actionJson.Values) {
        // First try to find each property using form > prefix.

        var values = actionJson.Values[name];
        var foundEl = $(form).find('input[name="' + prefix + name + '"],textarea[name="' + prefix + name + '"]');
        if (foundEl.length != 1) {
          foundEl = $(form).find('input[name="' + name + '"],textarea[name="' + name + '"]');
        }
        if (foundEl.length == 1) {
          if (foundEl.attr('disableUpdate') == undefined || foundEl.attr('disableUpdate') == null || foundEl.attr('disableUpdate') != 'true') {

            var dateRegex = /\Date\(([0-9]*)\)\//;
            var value = values[0];
            if (dateRegex.test(value)) {
              var date = new Date(parseInt(value.replace(dateRegex, '$1').replace(/\//gi, '')));
              value = $.datepicker.formatDate('yy-mm-dd', date);
              if (foundEl.is('.hasDatepicker'))
                foundEl.datepicker('setDate', date);
              else
                foundEl.val(value);
            } else {
              var value = values[0];
              if (value == null)
                value = '';
              foundEl.val(value);
            }
          }
          // Now try to find original
          if (values.length > 1) {
            var foundOriginalEl = $(form).find('input[name="' + prefix + name + '.original"],textarea[name="' + prefix + name + '.original"]');
            if (foundOriginalEl.length != 1) {
              foundOriginalEl = $(form).find('input[name="' + name + '.original"],textarea[name="' + name + '.original"]');
            }
            if (foundOriginalEl.length == 1) {
              var dateRegex = /\Date\(([0-9]*)\)\//;
              var value = values[1];
              if (dateRegex.test(value)) {
                var date = new Date(parseInt(RegExp.$1));
                value = $.datepicker.formatDate('yy-mm-dd', date);
                if (foundOriginalEl.is('.hasDatepicker'))
                  foundOriginalEl.datepicker('setDate', date);
                else
                  foundOriginalEl.val(value);
              } else {
                var value = values[1];
                if (value == null)
                  value = '';
                foundOriginalEl.val(value);
              }


            }

          }
        }

        // Second try to find each property using form > noprefix.
        // Third try to find each property using global > prefix.
        // Fourth try to find each property using global > noprefix.
      }
      return true;
    },

    UpdateModel: function (actionJson, originalEventData) {
      var prefix = "";
      if (actionJson.Prefix != "")
        prefix = actionJson.Prefix + ".";
      var form = originalEventData.source;
      if (form == undefined || (actionJson.FilterByForm != undefined && actionJson.FilterByForm == false))
        form = document;

      for (var name in actionJson.Values) {
        // First try to find each property using form > prefix.

        var values = actionJson.Values[name];
        var foundEl = $(form).find('input[name="' + prefix + name + '"],textarea[name="' + prefix + name + '"]');
        if (foundEl.length != 1) {
          foundEl = $(form).find('input[name="' + name + '"],textarea[name="' + name + '"]');
        }
        if (foundEl.length == 1) {
          if (foundEl.attr('disableUpdate') == undefined || foundEl.attr('disableUpdate') == null || foundEl.attr('disableUpdate') != 'true') {

            var dateRegex = /\Date\(([0-9]*)\)\//;
            var value = values[0];
            if (dateRegex.test(value)) {
              var date = new Date(parseInt(value.replace(dateRegex, '$1').replace(/\//gi, '')));
              value = $.datepicker.formatDate('yy-mm-dd', date);
              if (foundEl.is('.hasDatepicker'))
                foundEl.datepicker('setDate', date);
              else
                foundEl.val(value);
            } else {
              var value = values[0];
              if (value == null)
                value = '';
              foundEl.val(value);
            }
          }
          // Now try to find original
          if (values.length > 1) {
            var foundOriginalEl = $(form).find('input[name="' + prefix + name + '.original"],textarea[name="' + prefix + name + '.original"]');
            if (foundOriginalEl.length != 1) {
              foundOriginalEl = $(form).find('input[name="' + name + '.original"],textarea[name="' + name + '.original"]');
            }
            if (foundOriginalEl.length == 1) {
              var dateRegex = /\Date\(([0-9]*)\)\//;
              var value = values[1];
              if (dateRegex.test(value)) {
                var date = new Date(parseInt(RegExp.$1));
                value = $.datepicker.formatDate('yy-mm-dd', date);
                if (foundOriginalEl.is('.hasDatepicker'))
                  foundOriginalEl.datepicker('setDate', date);
                else
                  foundOriginalEl.val(value);
              } else {
                var value = values[1];
                if (value == null)
                  value = '';
                foundOriginalEl.val(value);
              }


            }

          }
        }

        // Second try to find each property using form > noprefix.
        // Third try to find each property using global > prefix.
        // Fourth try to find each property using global > noprefix.
      }
      return true;
    },
    UpdateModel: function (actionJson, originalEventData) {
      var prefix = "";
      if (actionJson.Prefix != "")
        prefix = actionJson.Prefix + ".";
      var form = originalEventData.source;
      if (form == undefined || (actionJson.FilterByForm != undefined && actionJson.FilterByForm == false))
        form = document;

      for (var name in actionJson.Values) {
        // First try to find each property using form > prefix.

        var values = actionJson.Values[name];
        var foundEl = $(form).find('input[name="' + prefix + name + '"],textarea[name="' + prefix + name + '"]');
        if (foundEl.length != 1) {
          foundEl = $(form).find('input[name="' + name + '"],textarea[name="' + name + '"]');
        }
        if (foundEl.length == 1) {
          if (foundEl.attr('disableUpdate') == undefined || foundEl.attr('disableUpdate') == null || foundEl.attr('disableUpdate') != 'true') {

            var dateRegex = /\Date\(([0-9]*)\)\//;
            var value = values[0];
            if (dateRegex.test(value)) {
              var date = new Date(parseInt(value.replace(dateRegex, '$1').replace(/\//gi, '')));
              value = $.datepicker.formatDate('yy-mm-dd', date);
              if (foundEl.is('.hasDatepicker'))
                foundEl.datepicker('setDate', date);
              else
                foundEl.val(value);
            } else {
              var value = values[0];
              if (value == null)
                value = '';
              foundEl.val(value);
            }
          }
          // Now try to find original
          if (values.length > 1) {
            var foundOriginalEl = $(form).find('input[name="' + prefix + name + '.original"],textarea[name="' + prefix + name + '.original"]');
            if (foundOriginalEl.length != 1) {
              foundOriginalEl = $(form).find('input[name="' + name + '.original"],textarea[name="' + name + '.original"]');
            }
            if (foundOriginalEl.length == 1) {
              var dateRegex = /\Date\(([0-9]*)\)\//;
              var value = values[1];
              if (dateRegex.test(value)) {
                var date = new Date(parseInt(RegExp.$1));
                value = $.datepicker.formatDate('yy-mm-dd', date);
                if (foundOriginalEl.is('.hasDatepicker'))
                  foundOriginalEl.datepicker('setDate', date);
                else
                  foundOriginalEl.val(value);
              } else {
                var value = values[1];
                if (value == null)
                  value = '';
                foundOriginalEl.val(value);
              }


            }

          }
        }

        // Second try to find each property using form > noprefix.
        // Third try to find each property using global > prefix.
        // Fourth try to find each property using global > noprefix.
      }
      return true;
    },

    UpdateViewModel: function (actionJson) {
      $(document.body).updateForm(actionJson.Values, actionJson.prefix);
      // Also, update the workflow
      if ($("#Navigator0").length > 0 && $("#Navigator0").attr('ajaxurl') != undefined && $("#Navigator0").attr('ajaxurl').length > 0)
        $("#Navigator0").load($("#Navigator0").attr('ajaxurl'));
    },

    ResubmitForm: function (actionJson, originalEventData) {


      if (originalEventData.trigger != undefined && originalEventData.trigger != null) {
        originalEventData.trigger();
        return true;
      } else if (originalEventData.source != undefined && originalEventData.source != null && $(originalEventData.source).get(0).tagName.toLowerCase() == "form") {
        $(originalEventData.source).submit();
        return true;
      }
      return false;
    }
  },
  handleAjaxResponse: function (responseJson, originalEventData, promise) {
    setTimeout(function() { $.hideLoadingSpinner(); }, 10);
		
    if (responseJson.ActionMessages == undefined || responseJson.ActionMessages.length === 0) { 
			promise && promise.resolve(responseJson);
      return false;
		}
    for (var i = 0; i < responseJson.ActionMessages.length; i++) {

      var responseMsg = responseJson.ActionMessages[i];
      if (responseMsg.ProcessedMessage == undefined || responseMsg.ProcessedMessage != true) {
        var actionName = responseMsg.Name;
        var handler = $.ajaxActionHandlers[actionName];
        if (handler != null) {
          var result = handler(responseMsg, originalEventData, promise, responseJson);
          if (result && result != null)
            responseMsg.ProcessedMessage = true;
        }
      }
    }
  }
});
